<template>
  <div ref="refChartPie"
       style="width: 100%; height: 100%;">
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      chartPie: null, // 图表指针
      optionPie: {} // 图表参数
    }
  },
  props: {
    updata: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.initPieOption()
  },
  beforeDestroy() {
    if (this.chartPie) this.chartPie.dispose()
  },
  watch: {
    updata: {
      handler(newData) {
        this.updatePieOption(newData)
      },
      // immediate: true, // 初始化后会立即触发一次
      deep: true // 深层监听 即遍历所有子对象 对性能稍有影响
    }
  },
  methods: {
    initPieOption() {
      this.chartPie = this.$echarts.init(this.$refs.refChartPie)
      this.updatePieOption(this.updata)
    },
    updatePieOption(newData) {
      let total = 0
      // let firstItemPercentage = 0.0 // 百分比
      // if (Array.isArray(newData.seriesData) && newData.seriesData.length > 0) {
      //   total = newData.seriesData.reduce((sum, item) => sum + item.value, 0)
      //   firstItemPercentage = ((newData.seriesData[0].value / total) * 100).toFixed(1)
      // }
      let txtTitle = ''
      let value0 = 0
      if (Array.isArray(newData.seriesData)) {
        for (let i = 0; i < newData.seriesData.length; i++) {
          total = total + newData.seriesData[i].value
          if (0 === i) value0 = newData.seriesData[i].value
        }
      }

      txtTitle = value0 + '/' + total

      this.optionPie = {
        title: {
          text: txtTitle, //主标题文本
          subtext: '已分配/总数', //副标题文本
          left: 'center',
          top: '40%',
          textStyle: {
            fontSize: 38,
            fontWeight: 800,
            fontFamily: 'DIN Condensed',
            color: '#03FFF5',
            align: 'center'
          },
          subtextStyle: {
            fontFamily: '微软雅黑',
            fontSize: 18,
            color: '#95D8FF'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 400,
            fontFamily: 'Source Han Sans SC',
            color: '#FFFFFF',
            align: 'left'
          },
          data: newData.seriesData.map((item) => item.name)
        },
        series: [
          {
            name: '分配情况',
            type: 'pie',
            radius: ['49%', '59%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: newData.seriesData
          }
        ],
        color: [
          {
            colorStops: [
              {
                color: '#214BE8',
                offset: 0
              },
              {
                color: '#03FFB1',
                offset: 1
              }
            ],
            global: false,
            type: 'linear',
            x: 0,
            x2: 1,
            y: 0,
            y2: 1
          },
          '#153B6D'
        ]
      }

      this.chartPie.setOption(this.optionPie, {
        notMerge: true, // 不合并以前的配置，直接使用新的配置覆盖
        lazyUpdate: true // 延迟更新视图，直到下一次渲染循环，这样可以批量更新多个属性而只触发一次重渲染，提高性能。
      })
    }
  }
}
</script>

<style scoped>
</style>